import { get } from '../apiClient';
import { API_ENDPOINTS } from '../config';

const globalSearchService = {
  search: async (filters = {}, signal) => {
    const queryParams = new URLSearchParams();

    [
      'search',
      'recordType',
      'mobileNumber',
      'name',
      'businessName',
      'city',
      'state',
      'page',
      'limit',
      'sortBy',
      'sortOrder'
    ].forEach((key) => {
      if (filters[key] !== undefined && filters[key] !== null && String(filters[key]).trim() !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const url = queryParams.toString()
      ? `${API_ENDPOINTS.CRM.GLOBAL_SEARCH}?${queryParams.toString()}`
      : API_ENDPOINTS.CRM.GLOBAL_SEARCH;

    const response = await get(url, { signal });

    if (response?.responseCode === 200) {
      return {
        success: true,
        records: response.data?.records || [],
        pagination: response.data?.pagination || {
          page: 1,
          limit: 20,
          total: 0,
          totalPages: 1
        }
      };
    }

    return {
      success: false,
      error: response?.responseMessage || 'Failed to search CRM records',
      records: [],
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
        totalPages: 1
      }
    };
  }
};

export default globalSearchService;
